import MicIcon from '@/assets/icons/mic.svg?react'
import { Button, Text } from '@/ui-kit'
import { useWavesurfer } from '@wavesurfer/react'
import clsx from 'clsx'
import { Pause, Play, SquareCheck } from 'lucide-react'
import { useRef } from 'react'
import { formatTime } from './AudioRecordingTask'

type RecordingStateRecordedProps = {
  audioUrl: string | null
  seconds: number
  isSubmitting: boolean
  onReRecord: () => void
  onSubmit: () => void
}

export const RecordingStateRecorded = ({
  audioUrl,
  seconds,
  isSubmitting,
  onReRecord,
  onSubmit
}: RecordingStateRecordedProps) => {
  const playerRef = useRef<HTMLDivElement>(null)

  const { wavesurfer, isPlaying } = useWavesurfer({
    container: playerRef,
    url: audioUrl || '',
    cursorColor: 'transparent',
    cursorWidth: 2,
    dragToSeek: false,
    duration: 10,
    height: 40,
    waveColor: '#727272',
    progressColor: '#39c900',
    autoplay: false,
    barWidth: 3,
    barHeight: 4
  })

  const onPlayPause = () => {
    wavesurfer?.playPause()
  }

  return (
    <div className="flex w-full flex-col items-center gap-6" style={{ animation: 'nectar-slide-up 0.3s ease-out' }}>
      <div className="flex flex-col items-center gap-2">
        <div className="relative flex items-center justify-center" style={{ width: 96, height: 96 }}>
          <div className="bg-red absolute inset-0 rounded-full opacity-25" />
          <button
            type="button"
            onClick={onReRecord}
            className="bg-red relative z-10 flex size-20 items-center justify-center rounded-full text-white shadow-lg transition-all duration-200 hover:scale-105"
          >
            <MicIcon className="h-12" />
          </button>
        </div>
        <Text type="body2-regular" className="text-gray-90">
          Re-record
        </Text>
      </div>

      <div className="my-2 flex w-full flex-col items-center gap-2">
        {audioUrl && (
          <div className="flex w-full items-center gap-2">
            <div className={clsx('h-10 w-full flex-1')} ref={playerRef}></div>
            <div className="text-body2-regular text-gray-90 flex items-center gap-3">{formatTime(seconds)}</div>
          </div>
        )}
        {seconds < 1 && !isSubmitting && (
          <Text type="body3-regular" className="text-red-500">
            Recording is too short
          </Text>
        )}
      </div>
      <div className="flex items-center gap-2">
        <Button
          onClick={onPlayPause}
          variant={'tertiary'}
          size="small"
          className="hover:bg-transparent! hover:text-green! flex w-[115px] items-center gap-1"
        >
          {isPlaying ? (
            <>
              <Pause className="h-4 w-4 shrink-0" />
              Pause
            </>
          ) : (
            <>
              <Play className="h-4 w-4 shrink-0" />
              Play
            </>
          )}
        </Button>
        <Button
          size="small"
          variant="green"
          onClick={onSubmit}
          isDisabled={isSubmitting || seconds < 1}
          className="flex w-[115px] items-center gap-1"
        >
          <SquareCheck className="h-4 w-4 shrink-0" />
          {isSubmitting ? 'Sending...' : 'Submit'}
        </Button>
      </div>
    </div>
  )
}
